import { CONTEXT_CAPTURE_AREAS } from '../constants/feedback';
import { readDiagnostics } from './feedbackDiagnostics';
import { readStorageSnapshot } from './feedbackStorageSnapshot';
import { readFeedbackPageContext } from '../providers/feedbackPageContext';

/**
 * Assemble the `context` blob attached to a feedback report.
 *
 * Two tiers. The always-on tier costs nothing and applies to any report:
 * where the user was, on what build, in what browser. The portal tier —
 * page state, persisted UI settings, recent errors — is only collected
 * when the report is *about* the portal, because there is no portal
 * screen state worth reading when the complaint is about a device.
 */
export function buildFeedbackContext(productArea: number, route: string): Record<string, unknown> {
  const context: Record<string, unknown> = {
    route,
    captured_at: new Date().toISOString(),
    app_version: typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'unknown',
    user_agent: navigator.userAgent,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  if (!CONTEXT_CAPTURE_AREAS.includes(productArea)) return context;

  const page = readFeedbackPageContext();
  if (Object.keys(page).length) context.page = page;

  const storage = readStorageSnapshot();
  if (Object.keys(storage.values).length || storage.skipped_key_count) context.stored_ui_state = storage;

  const diagnostics = readDiagnostics();
  if (diagnostics.console_errors.length) context.console_errors = diagnostics.console_errors;
  if (diagnostics.api_failures.length) context.api_failures = diagnostics.api_failures;

  return context;
}
